import { storeDispatchTypes } from '../../../modules/store/storeDispatchTypes'
import { SortFieldParts } from '../../../types/common/commonTypes'
import TableHeadRangeFilter from '../../_atoms/TableHeadRangeFilter/TableHeadRangeFilter'

interface IProps {
    initialFromVal: number | undefined
    initialToVal: number | undefined
}

const TableHeadQuantityRangeParts = ({ initialFromVal, initialToVal }: IProps) => (
    <TableHeadRangeFilter
        initialTableHead={'Кол.'}
        step={1000}
        leftInPixes={-35}
        initialFromVal={initialFromVal}
        initialToVal={initialToVal}
        widthInPixels={150}
        storeActionSetRange={storeDispatchTypes.setQuantityRangeParts}
        sortField={SortFieldParts.QUANTITY}
        isColumnSort
    />
)

export default TableHeadQuantityRangeParts
